import React, { Component } from "react";
import { Image, Button, Badge } from "react-bootstrap";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";

import RestaurantStyle from "./style";

// Helper
import {
  _renderRestaurantProfilePic,
  _renderRestaurantCoverPic,
  _renderCloseTime,
} from "../../helpers/Utility";

// Redux
import { connect } from "react-redux";
import * as actions from "../../redux/actions";
import Icon from "../Icon";
import Color from "../../assets/color";

// Component
import Rating from "./Component/Rating";
import ImageLightbox from "../../components/ImageLightbox";

class RestaurantCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      lightboxVisible: false,
      lightboxImage: [],
    };
  }

  componentDidMount() {
    if (this.props.restaurantID)
      this.props.onLoadRestaurantDetail(this.props.restaurantID);
  }

  _goToRestaurantDetail = id => {
    this.props.history.push(`/restaurant/?restaurant=${id}`);
  };

  _onShowImageLightbox = image => {
    this.setState({
      lightboxVisible: true,
      lightboxImage: [{ src: image, caption: null }],
    });
  };

  _hideLightbox = () => {
    this.setState({ lightboxVisible: false, lightboxImage: [] });
  };

  render() {
    const { restaurantDetail, showCollectMode } = this.props;
    const { lightboxVisible, lightboxImage } = this.state;

    return (
      <RestaurantStyle>
        <div className="restaurant-menu-card">
          <div className="restaurant-photo-container">
            <Image
              className="cover-photo mx-auto"
              src={_renderRestaurantCoverPic(restaurantDetail.Media)}
              onClick={() => {
                this._onShowImageLightbox(
                  _renderRestaurantProfilePic(restaurantDetail.Media)
                );
              }}
            />
            <Image
              className="profile-photo mx-auto"
              src={_renderRestaurantProfilePic(restaurantDetail.Media)}
              onClick={() => {
                this._onShowImageLightbox(
                  _renderRestaurantProfilePic(restaurantDetail.Media)
                );
              }}
            />

            {lightboxVisible && (
              <ImageLightbox
                images={lightboxImage}
                onClose={this._hideLightbox}
                modalStyle={{
                  overlay: {
                    backgroundColor: Color.black,
                  },
                }}
              />
            )}

            {restaurantDetail.openNow === 1 ? (
              <Badge pill variant={"success"} className="badge-status">
                Open Now
              </Badge>
            ) : restaurantDetail.RestaurantSetting.preorder === true &&
              restaurantDetail.RestaurantSetting.preorder_now !== true ? (
              <Badge pill variant={"success"} className="badge-status">
                Open Now
              </Badge>
            ) : (
              <Badge pill variant={"danger"} className="badge-status">
                {_renderCloseTime(restaurantDetail)}
              </Badge>
            )}
          </div>
          <div className="pt-3 px-3 pb-2">
            <h3>{restaurantDetail ? restaurantDetail.restaurant_name : ""}</h3>
            <Rating
              rating={restaurantDetail.avg_rating}
              total_vote={restaurantDetail.total_vote}
            />
            {restaurantDetail.cuisine.length !== 0 && (
              <div className="d-flex flex-wrap">
                {restaurantDetail.cuisine.map((cuisine, index) => {
                  return (
                    <div className="d-flex align-items-center mr-2" key={index}>
                      {index !== 0 && (
                        <Icon
                          type="font-awesome"
                          name="circle"
                          size={8}
                          color={Color.aluminium}
                          className="ml-2"
                        />
                      )}
                      <span className={`cuisine ${index !== 0 && "ml-2"}`}>
                        {cuisine}
                      </span>
                    </div>
                  );
                })}
              </div>
            )}
            <div className="d-flex d-sm-block">
              <Button
                className={`mt-2 ${showCollectMode ? "mr-1 mr-sm-0" : ""} `}
                variant="primary"
                block
                onClick={() =>
                  this._goToRestaurantDetail(restaurantDetail.restaurant_id)
                }
              >
                Details
              </Button>
              {showCollectMode && (
                <Button
                  className="mt-2 ml-1 ml-sm-0 d-lg-none"
                  variant="outline-secondary"
                  block
                  onClick={this.props.onClickCollectMode}
                >
                  Collect Mode
                </Button>
              )}
            </div>
          </div>
        </div>
      </RestaurantStyle>
    );
  }
}

RestaurantCard.propTypes = {
  restaurantDetail: PropTypes.object.isRequired,
  // Function
  onLoadRestaurantDetail: PropTypes.func.isRequired,
};

const mapStateToProps = state => {
  return {
    restaurantDetail: state.Restaurant.restaurantDetail,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onLoadRestaurantDetail: params =>
      dispatch(actions.getRestaurantDetail(params)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(RestaurantCard)
);
